export default function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/nodes.js
// module id = 406
// module chunks = 0 1 2 3 4